import gql from "graphql-tag";

export const GIFT_CARD_QUERY = gql`
  query GiftCard($id: ID!) {
    giftCard(id: $id) {
      id
      claimAt
      expiresAt
      redeemAt
      price {
        id
        name
        description
        price
        recurringInterval
        behavior
        trialDays
        installments
        guaranteeDays
        active
        sortOrder
        visible
        product {
          id
          name
          description
          color
          active
          visible
          sortOrder
          options {
            id
            name
            value
          }
        }
      }
      deal {
        termsOfUseUrl
        description
        imageUrl
      }
    }
  }
`;

//privacyPolicyUrl
